;
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { FaBookmark } from "react-icons/fa";
import { MdDesignServices } from "react-icons/md";
import TtkList from './TtkList';
const EntryThemeTTK = ({ data }) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className='row mb-1'>
                    <div className='col-md-3'>
                        <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since:</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                    </div>
                    <div className='col-md-3'>
                        <p ><FaBookmark sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>No of Events Covered :</b>&nbsp;<span>{data?.CoverdofEvents}</span></p>
                    </div>
                    <div className='col-md-3'>
                        <p> <MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Price :</b>&nbsp;&#8377;&nbsp;<span>{data?.startingPrice}</span></p>
                    </div>
                    <div className='col-md-3'>
                        <p> <MdDesignServices size={20} sx={{ fontSize: 25 }} style={{ color: "black" }} />&nbsp;<b>Service Type :</b>&nbsp;<TtkList data={data?.serviceType}/></p>
                    </div>
                </div>
                <div className='row mb-1'>
                    <div className='col-md-3'>
                        <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of Working :</b>&nbsp;<TtkList data={data?.areaOfWork}/></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EntryThemeTTK